import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/developer3.css';
import './css/radio.css';
import { BrowserRouter, HashRouter } from "react-router-dom";
import Auth from './Auth';


ReactDOM.render(
  
  <HashRouter hashType='noslash'>
  <Auth />
  </HashRouter>,
  document.getElementById("root")
  
);

